const overloadColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 480
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model'
  },
  {
    zh: '换算后额定功率(kw)',
    en: 'Conversion Rated Power(kw)',
    dataIndex: 'conversionRatedPower',
    key: 'conversionRatedPower',
    tooltip: true
  },
  {
    zh: '额定功率(kw)',
    en: 'Rated Power(kw)',
    dataIndex: 'ratedPower',
    key: 'ratedPower'
  },
  {
    zh: '过载率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    fixed: 0
  }
]

export {
  overloadColumns
}
